"use client"
import React, {useState, useEffect} from "react";

interface TypewritterProps {
    text: string;
    speed?: number;
}

export default function Typewriter({text, speed = 100}: TypewritterProps) {
    const [displayedText, setDisplayedText] = useState("");
    const [index, setIndex] = useState(0);

    useEffect(() => {
        setDisplayedText("");
        setIndex(0);
    }, [text]);

    useEffect(() => {
        if (index >= text.length) return;

        const intervalId = setInterval(() => {
            setDisplayedText((prev) => prev + text.charAt(index));
            setIndex((prevIndex) => prevIndex + 1);
        }, speed);

        return () => clearInterval(intervalId);
    }, [index, text, speed]);

    return displayedText;
}
